import React from 'react';
import { challengeSummaryPanelClass, hintClass, sectionLabelClass } from './challengeWireFormStyles';
import {
	buildChallengeScheduleLine,
	buildMutualSupportLine,
	challengeFirstName,
	formatNameList
} from '../../utils/challengeSummaryDisplay';
import ChallengeLinkIcon from './ChallengeLinkIcon';

export default function ChallengeSendSummary({
	challengerName,
	challengedName,
	challengedNames,
	title,
	startsOn,
	endsOn,
	personalNote,
	alsoJoin = false
}) {
	const challenger = challengeFirstName(challengerName) || challengerName || 'Someone';
	const sourceNames = (Array.isArray(challengedNames) && challengedNames.length > 0
		? challengedNames
		: [challengedName]
	).filter((name) => name != null);
	const challengedLabelList = sourceNames
		.map((name) => challengeFirstName(name) || name)
		.filter(Boolean);
	const challenged = formatNameList(challengedLabelList) || 'someone';
	const challengeTitle = title?.trim();
	const primaryChallengedName = sourceNames.find((name) => name?.trim());
	const isSelfChallenge =
		challengedLabelList.length <= 1 &&
		Boolean(challengerName?.trim() && primaryChallengedName?.trim()) &&
		challengerName.trim().toLowerCase() === primaryChallengedName.trim().toLowerCase();

	if (!startsOn || !endsOn || !challenger || !challenged) {
		return null;
	}

	if (!challengeTitle) {
		return (
			<div
				className="min-w-0 rounded-xl border border-red-200 dark:border-red-800 bg-white dark:bg-dark-bg p-4 sm:p-5 space-y-3"
				aria-live="polite"
			>
				<p className={sectionLabelClass}>Summary</p>
				<p className="text-sm text-red-600 dark:text-red-400" role="alert">
					Add a challenge title to see the summary card.
				</p>
			</div>
		);
	}

	const scheduleLine = buildChallengeScheduleLine(startsOn, endsOn);
	const note = personalNote?.trim();

	return (
		<div className={challengeSummaryPanelClass} aria-live="polite">
			<p className={sectionLabelClass}>Summary</p>
			<div className="space-y-2 text-sm leading-relaxed text-gray-800 dark:text-dark-text">
				<p>
					{isSelfChallenge ? (
						<>
							<strong className="font-semibold text-gray-900 dark:text-dark-text">{challenger}</strong>
							{' challenges themselves to:'}
						</>
					) : (
						<>
							<strong className="font-semibold text-gray-900 dark:text-dark-text">{challenger}</strong>
							{' challenges '}
							<strong className="font-semibold text-gray-900 dark:text-dark-text">{challenged}</strong>
							{' to:'}
						</>
					)}
				</p>
				<p className="text-base font-semibold text-gray-900 dark:text-dark-text">{challengeTitle}</p>
				{scheduleLine && <p>{scheduleLine}</p>}
				{note ? (
					<blockquote className="border-l-2 border-blue-300 dark:border-blue-600 pl-3 italic text-gray-600 dark:text-gray-400">
						{note}
					</blockquote>
				) : null}
				{alsoJoin ? (
					<p className={`${hintClass} flex items-start gap-2`}>
						<ChallengeLinkIcon />
						<span>{buildMutualSupportLine(challengerName)}</span>
					</p>
				) : null}
			</div>
			<p className={hintClass}>This is what they'll see on the challenge card.</p>
		</div>
	);
}
